import {ColumnMain} from "#/models/column-main";
import {Column} from "#/models/column";
import {Trans} from "@lingui/macro";
import {Tag} from "antd";
import React from "react";

const EmailModel = () : ColumnMain => {

    const columns : Array<Column> = new Array();
    
    columns.push({key:'id', width: 80, filter:true, sorter:true, title:<Trans>ID</Trans>});
    columns.push({key:'recipients', width: 250, filter:true, sorter:true, title:<Trans>Recipients</Trans>});
    columns.push({key:'subject', width: 300, filter:true, sorter:true, title:<Trans>Subject</Trans>});
    columns.push({key:'type', width: 150, filter:true, sorter:true, title:<Trans>Type</Trans>});
    columns.push({key:'status', width: 130, filter:true, sorter:true, title:<Trans>Status</Trans>});
    columns.push({key:'sentAt', width: 180, dateTimeFilter:true, sorter:true, title:<Trans>Sent At</Trans>});
    columns.push({key:'updatedDate', width: 180, dateTimeFilter:true, sorter:true, title:<Trans>Updated Date</Trans>});
    columns.push({key:'updatedBy', width: 150, filter:true, sorter:true, title:<Trans>Updated By</Trans>});
    columns.push({key:'createdDate', width: 180, dateTimeFilter:true, sorter:true, title:<Trans>Created Date</Trans>, direction:"desc"});
    columns.push({key:'createdBy', width: 150, filter:true, sorter:true, title:<Trans>Created By</Trans>});

    return{
        columns:columns,
        url:"/resource/emails"
    };

}
export default EmailModel();
